import { render, staticRenderFns } from "./Success.vue?vue&type=template&id=34939165&scoped=true"
import script from "./Success.vue?vue&type=script&lang=ts"
export * from "./Success.vue?vue&type=script&lang=ts"
import style0 from "./Success.vue?vue&type=style&index=0&id=34939165&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34939165",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CBtnNew: require('/home/runner/work/dena.ai.renewal/dena.ai.renewal/frontend/components/content/c-btn-new.vue').default})
